<nf-grid-wrapper
  [hideSearch]="true"
  [hideClearAll]="true"
  *nfLoader="isLoading"
>
  <nf-grid-wrapper-header-left class="file-title header-size">
    <nf-checkbox
      class="security-Check"
      [formControl]="paysOnLiquidationToggle"
      label="Pays Upon Liquidation"
    ></nf-checkbox>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right class="accounts-label header-size">
    <button
      nf-button="primary"
      ngbTooltip="Add Calendar"
      placement="auto"
      (click)="openMmfCalendar()"
    >
      Add Calendar
    </button>
  </ng-grid-wrapper-header-right>

  <nf-grid-wrapper-content>
    <nf-table-layout
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [data]="mmfAccountData"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
      hideTitle
    ></nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
